import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import useServiceCenters from '~/modules/common/enhancers/useServiceCenters';
import { useAdditionalOptions } from '~/modules/common/hooks';
import { useOptionsMerge } from '~/modules/common/components/SearchAutocomplete';
import GroupDropdown from './GroupDropdown';
import { useStyledGroupLabels } from './hooks';

export const ServiceCenterDropdown = ({
  classes,
  groupSettings,
  value = '',
  policy,
  onChange,
  enableNoChangeOption = false,
  enableNoValueOption = false,
  ...rest
}) => {
  const { formatMessage } = useIntl();
  const { serviceCenter: serviceCenterLabel } = useStyledGroupLabels();
  const [searchTerm, setSearchTerm] = useState('');

  const { serviceCenters, loading, hasMore } = useServiceCenters({
    searchTerm,
    policy
  });

  const additionalOptions = useAdditionalOptions({
    enableNoChangeOption,
    enableNoValueOption,
    noValueMessageId: 'dropdownItem.noServiceCenter'
  });

  const noGroupsText = groupSettings.singularName
    ? formatMessage(
        { id: 'groupsDropdown.noGroup' },
        { group: groupSettings.singularName }
      )
    : formatMessage({ id: 'serviceCenterDropdown.noServiceCenter' });

  const options = useOptionsMerge({
    options: serviceCenters,
    additionalOptions
  });

  return (
    <GroupDropdown
      hasMore={hasMore}
      classes={classes}
      options={options}
      label={serviceCenterLabel}
      value={value}
      loading={loading}
      setSearchTerm={setSearchTerm}
      noOptionsText={noGroupsText}
      onChange={onChange}
      optionTypeText={formatMessage({
        id: 'moreOptions.serviceCenter'
      })}
      {...rest}
    />
  );
};

ServiceCenterDropdown.propTypes = {
  classes: PropTypes.object,
  groupSettings: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.object,
  policy: PropTypes.string,
  enableNoChangeOption: PropTypes.bool,
  enableNoValueOption: PropTypes.bool
};

export default ServiceCenterDropdown;
